import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Package, Crown, Sparkles } from "lucide-react";
import { ICONS } from "@/components/marketplace/marketplaceIcons";

export function AvailableServices({ services }) {
  const navigate = useNavigate();

  if (services.length === 0) return null;

  return (
    <div className="space-y-4">
      {services.map(svc => {
        const Icon = ICONS[svc.icon] || Package;
        return (
          <Card
            key={svc.id}
            className="border-2 border-pink-300 bg-gradient-to-br from-white to-pink-50/30 hover:shadow-lg transition-all"
            data-testid={`service-card-${svc.id}`}
          >
            <CardContent className="p-5">
              <div className="flex flex-col md:flex-row md:items-center gap-4">
                <div className={`p-3 rounded-xl ${svc.color} shrink-0`}>
                  <Icon className={`w-6 h-6 ${svc.iconColor}`} />
                </div>

                <div className="flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-bold text-lg">{svc.name}</h3>
                    {svc.isPremium && <Crown className="w-4 h-4 text-amber-500" />}
                    <Badge className="bg-emerald-100 text-emerald-700 border-emerald-200">
                      <Sparkles className="w-3 h-3 mr-1" />
                      Disponível
                    </Badge>
                  </div>
                  <p className="text-sm text-muted-foreground mt-1">{svc.description}</p>
                </div>

                <div className="flex items-center gap-4 shrink-0">
                  <span className="text-sm font-semibold text-pink-600">{svc.price}</span>
                  <Button
                    className="bg-pink-500 hover:bg-pink-600 text-white"
                    onClick={() => svc.route && navigate(svc.route)}
                    data-testid={`service-access-${svc.id}`}
                  >
                    Acessar
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
